import { AmpersandIcon } from './AmpersandIcon';

/**
 * author: Michael Irigoyen
 * id CC5AC69B-0EAA-454A-8757-4F670F478952
 * name ampersand
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ampersand.svg
 * tags
 */
export const AndIcon = AmpersandIcon;
export default AndIcon